import React from "react";
import { Button, withMobile } from "components/common";
import { colors } from "theme";
import classnames from "classnames";

const SettingsButton = onComplete => ({
  mobileContext: { isMobile },
  onClick,
  children,
  className,
  buttonContainerClassName,
  disabled,
  paddingHorizontal
}) => (
  <Button
    green={true}
    onClick={async () => {
      if (onClick) {
        const result = await onClick();
        if (result) onComplete(result);
      }
    }}
    disabled={disabled}
    buttonContainerClassName={buttonContainerClassName}
    className={classnames(className, { "w-full font-semibold": isMobile })}
    paddingVertical={isMobile ? "12px" : "8px"}
  >
    {children}
  </Button>
);

SettingsButton.defaultProps = {
  className: ""
};

export default onComplete => withMobile(SettingsButton(onComplete));
